export function getRedirectPath(pathname, dashboardOnly, firebaseCredentials) {
  const currentPath = pathname;

  const exemptPaths = [
    "/embed",
    "/reset-password",
    "/auth-group",
    "/viewcontent",
    "/chatembed",
    "/group/about",
    "/lead",
    "/discover",
    "/share",
    "/dashboard"
  ];

  if (exemptPaths.some(path => currentPath.includes(path)) || currentPath.includes("discover")) {
    return null;
  }

  if (!dashboardOnly) {
    return null;
  }

  return "/dashboard";
}
